import FirstDeal from './components/FirstDeal.vue'
import Main from './components/Main.vue'

export default [
    {
        name: 'dashboard.index',
        path: '/dashboard',
        component: Main,
        meta: {
            requiresAuth: true
        }
    },
    {
        name: 'dashboard.first-deal',
        path: '/first-deal',
        component: FirstDeal,
        meta: {
            requiresAuth: true
        }
    }
]



// WEBPACK FOOTER //
// ./src/modules/dashboard/routes.js